module.exports = __webpack_public_path__ + "img/mini-logo.f7d56eec.png";